import React from "react";

const MarkAiChat = () => {
  return <div>MarkAiChat</div>;
};

export default MarkAiChat;
